import { useContext } from 'react'
import { CoreContext } from 'lib/core/resources/context'

export const useCoreContext = () => {
  return useContext(CoreContext)
}
